import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-server-unreachable-overlay',
  templateUrl: './server-unreachable-overlay.component.html',
  styleUrls: ['./server-unreachable-overlay.component.scss'],
  imports: [TranslocoModule, MatButtonModule, MatIconModule]
})
export class ServerUnreachableOverlayComponent {
  retry(): void {
    location.reload();
  }
}
